import { Component, Input, ViewChild } from '@angular/core';
import { RadioElementDirective } from './radio-element.directive';

@Component({
  selector: 'opac-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent {
  /**
   * Get radio element directive
   */
  @ViewChild('opacRadioElement', { static: true }) directive!: RadioElementDirective;

  /**
   * Determines radio checked state
   */
  @Input() checked: boolean = false;
  /**
   * Sets boolean disabled state
   */
  @Input() disabled: boolean = false;
  /**
   * Determines radio group name to work with other radios
   */
  @Input() name: string = '';
  /**
   * Determines input value
   */
  @Input() value: string;
}
